import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import { Router } from './core/router';
import { GlobalUtilProvider } from './core/contexts';
import { InAppLayout } from './core/layouts';
import { LoadingOverlay } from './core/components/LoadingOverlay';

function App() {
  return (
    <GlobalUtilProvider>
      <CssBaseline />
      <LoadingOverlay />
      <InAppLayout>
        <Router />
      </InAppLayout>
    </GlobalUtilProvider>
  );
}

export default App;
